import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../stylesheet/retailer/helper/QuickActions.css'


const QuickActions = () => {
  const navigate = useNavigate();

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="col connectedSortable">
      <div className="card text-white bg-primary bg-gradient border-primary mb-4">
        <div className="card-header border-0 d-flex justify-content-between align-items-center">
          <h3 className="card-title mb-0">
            <i className="bi bi-lightning-charge-fill me-2"></i> Quick Actions
          </h3>
          <div className="card-tools">
            <button type="button" className="btn btn-primary btn-sm" data-lte-toggle="card-collapse">
              <i data-lte-icon="expand" className="bi bi-plus-lg"></i>
              <i data-lte-icon="collapse" className="bi bi-dash-lg"></i>
            </button>
          </div>
        </div>
        <div className="card-body p-2">
          <div className="row g-2">
            {/* First Row */}
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/accounts')}>
                <i className="bi bi-people-fill fs-3 mb-2"></i>
                <span className="text-wrap">Create Party</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/items')}>
                <i className="bi bi-box-seam-fill fs-3 mb-2"></i>
                <span className="text-wrap">Create Items</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/purchase')}>
                <i className="bi bi-cart-plus-fill fs-3 mb-2"></i>
                <span className="text-wrap">Purchase</span>
              </button>
            </div>

            {/* Second Row */}
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/cash-sales')}>
                <i className="bi bi-cash-coin fs-3 mb-2"></i>
                <span className="text-wrap">Cash Sales</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/cash-sales/open')}>
                <i className="bi bi-cash-stack fs-3 mb-2"></i>
                <span className="text-wrap">Cash Sales Open</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/credit-sales')}>
                <i className="bi bi-credit-card fs-3 mb-2"></i>
                <span className="text-wrap">Credit Sales</span>
              </button>
            </div>

            {/* Third Row */}
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/credit-sales/open')}>
                <i className="bi bi-credit-card-2-front fs-3 mb-2"></i>
                <span className="text-wrap">Credit Sales Open</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/payments')}>
                <i className="bi bi-arrow-up-circle fs-3 mb-2"></i>
                <span className="text-wrap">Payment</span>
              </button>
            </div>
            <div className="col-md-4 d-flex">
              <button
                className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2 action-btn"
                onClick={() => handleActionClick('/api/retailer/receipts')}>
                <i className="bi bi-arrow-down-circle fs-3 mb-2"></i>
                <span className="text-wrap">Receipt</span>
              </button>
            </div>
          </div>
        </div>
        {/* <div className="card-footer border-0 pt-2 pb-3">
          <div className="row g-0">
            <div className="col-4 text-center">
              <button 
                className="text-white d-block p-2 hover-effect bg-transparent border-0 w-100"
                onClick={() => handleActionClick('/parties')}>
                <i className="bi bi-people-fill fs-4 d-block"></i>
                <small>Parties</small>
              </button>
            </div>
            <div className="col-4 text-center">
              <button 
                className="text-white d-block p-2 hover-effect bg-transparent border-0 w-100"
                onClick={() => handleActionClick('/items')}>
                <i className="bi bi-box-fill fs-4 d-block"></i>
                <small>Items</small>
              </button>
            </div>
            <div className="col-4 text-center">
              <button 
                className="text-white d-block p-2 hover-effect bg-transparent border-0 w-100"
                onClick={() => handleActionClick('/api/retailer/statement')}>
                <i className="bi bi-graph-up-arrow fs-4 d-block"></i>
                <small>Reports</small>
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default QuickActions;